import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { config } from "../../app.config";
import { InputFactory } from "../Factories/Input";

const dialingCodes = _.mapValues(
  _.keyBy(
    [
      { icon: "🇦🇫", code: 93 },
      { icon: "🇦🇱", code: 355 },
      { icon: "🇩🇿", code: 213 },
      { icon: "🇦🇸", code: 1684 },
      { icon: "🇦🇩", code: 376 },
      { icon: "🇦🇴", code: 244 },
      { icon: "🇦🇮", code: 1264 },
      { icon: "🇦🇶", code: 0 },
      { icon: "🇦🇷", code: 54 },
      { icon: "🇦🇲", code: 374 },
      { icon: "🇦🇼", code: 297 },
      { icon: "🇦🇺", code: 61 },
      { icon: "🇦🇹", code: 43 },
      { icon: "🇦🇿", code: 994 },
      { icon: "🇧🇭", code: 973 },
      { icon: "🇧🇩", code: 880 },
      { icon: "🇧🇧", code: 1246 },
      { icon: "🇧🇾", code: 375 },
      { icon: "🇧🇪", code: 32 },
      { icon: "🇧🇿", code: 501 },
      { icon: "🇧🇯", code: 229 },
      { icon: "🇧🇲", code: 1441 },
      { icon: "🇧🇹", code: 975 },
      { icon: "🇧🇴", code: 591 },
      { icon: "🇧🇼", code: 267 },
      { icon: "🇧🇻", code: 0 },
      { icon: "🇧🇷", code: 55 },
      { icon: "🇮🇴", code: 246 },
      { icon: "🇧🇳", code: 673 },
      { icon: "🇧🇬", code: 359 },
      { icon: "🇧🇫", code: 226 },
      { icon: "🇧🇮", code: 257 },
      { icon: "🇰🇭", code: 855 },
      { icon: "🇨🇲", code: 237 },
      { icon: "🇨🇦", code: 1 },
      { icon: "🇨🇻", code: 238 },
      { icon: "🇰🇾", code: 1345 },
      { icon: "🇨🇫", code: 236 },
      { icon: "🇹🇩", code: 235 },
      { icon: "🇨🇱", code: 56 },
      { icon: "🇨🇳", code: 86 },
      { icon: "🇨🇽", code: 61 },
      { icon: "🇨🇨", code: 672 },
      { icon: "🇨🇴", code: 57 },
      { icon: "🇰🇲", code: 269 },
      { icon: "🇨🇰", code: 682 },
      { icon: "🇨🇷", code: 506 },
      { icon: "🇨🇺", code: 53 },
      { icon: "🇨🇾", code: 357 },
      { icon: "🇩🇰", code: 45 },
      { icon: "🇩🇯", code: 253 },
      { icon: "🇩🇲", code: 1767 },
      { icon: "🇩🇴", code: 1809 },
      { icon: "🇪🇨", code: 593 },
      { icon: "🇪🇬", code: 20 },
      { icon: "🇸🇻", code: 503 },
      { icon: "🇬🇶", code: 240 },
      { icon: "🇪🇷", code: 291 },
      { icon: "🇪🇪", code: 372 },
      { icon: "🇪🇹", code: 251 },
      { icon: "🇫🇰", code: 500 },
      { icon: "🇫🇴", code: 298 },
      { icon: "🇫🇮", code: 358 },
      { icon: "🇫🇷", code: 33 },
      { icon: "🇬🇫", code: 594 },
      { icon: "🇵🇫", code: 689 },
      { icon: "🇹🇫", code: 0 },
      { icon: "🇬🇦", code: 241 },
      { icon: "🇬🇪", code: 995 },
      { icon: "🇩🇪", code: 49 },
      { icon: "🇬🇭", code: 233 },
      { icon: "🇬🇮", code: 350 },
      { icon: "🇬🇷", code: 30 },
      { icon: "🇬🇱", code: 299 },
      { icon: "🇬🇩", code: 1473 },
      { icon: "🇬🇵", code: 590 },
      { icon: "🇬🇺", code: 1671 },
      { icon: "🇬🇹", code: 502 },
      { icon: "🇬🇳", code: 224 },
      { icon: "🇬🇼", code: 245 },
      { icon: "🇬🇾", code: 592 },
      { icon: "🇭🇹", code: 509 },
      { icon: "🇭🇳", code: 504 },
      { icon: "🇭🇺", code: 36 },
      { icon: "🇮🇸", code: 354 },
      { icon: "🇮🇳", code: 91 },
      { icon: "🇮🇩", code: 62 },
      { icon: "🇮🇷", code: 98 },
      { icon: "🇮🇶", code: 964 },
      { icon: "🇮🇪", code: 353 },
      { icon: "🇮🇱", code: 972 },
      { icon: "🇮🇹", code: 39 },
      { icon: "🇯🇲", code: 1876 },
      { icon: "🇯🇵", code: 81 },
      { icon: "🇯🇴", code: 962 },
      { icon: "🇰🇿", code: 7 },
      { icon: "🇰🇪", code: 254 },
      { icon: "🇰🇮", code: 686 },
      { icon: "🇰🇼", code: 965 },
      { icon: "🇰🇬", code: 996 },
      { icon: "🇱🇦", code: 856 },
      { icon: "🇱🇻", code: 371 },
      { icon: "🇱🇧", code: 961 },
      { icon: "🇱🇸", code: 266 },
      { icon: "🇱🇷", code: 231 },
      { icon: "🇱🇾", code: 218 },
      { icon: "🇱🇮", code: 423 },
      { icon: "🇱🇹", code: 370 },
      { icon: "🇱🇺", code: 352 },
      { icon: "🇲🇰", code: 389 },
      { icon: "🇲🇬", code: 261 },
      { icon: "🇲🇼", code: 265 },
      { icon: "🇲🇾", code: 60 },
      { icon: "🇲🇻", code: 960 },
      { icon: "🇲🇱", code: 223 },
      { icon: "🇲🇹", code: 356 },
      { icon: "🇲🇭", code: 692 },
      { icon: "🇲🇶", code: 596 },
      { icon: "🇲🇷", code: 222 },
      { icon: "🇲🇺", code: 230 },
      { icon: "🇾🇹", code: 269 },
      { icon: "🇲🇽", code: 52 },
      { icon: "🇫🇲", code: 691 },
      { icon: "🇲🇩", code: 373 },
      { icon: "🇲🇨", code: 377 },
      { icon: "🇲🇳", code: 976 },
      { icon: "🇲🇸", code: 1664 },
      { icon: "🇲🇦", code: 212 },
      { icon: "🇲🇿", code: 258 },
      { icon: "🇳🇦", code: 264 },
      { icon: "🇳🇷", code: 674 },
      { icon: "🇳🇵", code: 977 },
      { icon: "🇳🇨", code: 687 },
      { icon: "🇳🇿", code: 64 },
      { icon: "🇳🇮", code: 505 },
      { icon: "🇳🇪", code: 227 },
      { icon: "🇳🇬", code: 234 },
      { icon: "🇳🇺", code: 683 },
      { icon: "🇳🇫", code: 672 },
      { icon: "🇲🇵", code: 1670 },
      { icon: "🇳🇴", code: 47 },
      { icon: "🇴🇲", code: 968 },
      { icon: "🇵🇰", code: 92 },
      { icon: "🇵🇼", code: 680 },
      { icon: "🇵🇦", code: 507 },
      { icon: "🇵🇾", code: 595 },
      { icon: "🇵🇪", code: 51 },
      { icon: "🇵🇭", code: 63 },
      { icon: "🇵🇱", code: 48 },
      { icon: "🇵🇹", code: 351 },
      { icon: "🇵🇷", code: 1787 },
      { icon: "🇶🇦", code: 974 },
      { icon: "🇷🇴", code: 40 },
      { icon: "🇷🇺", code: 70 },
      { icon: "🇷🇼", code: 250 },
      { icon: "🇼🇸", code: 684 },
      { icon: "🇸🇲", code: 378 },
      { icon: "🇸🇦", code: 966 },
      { icon: "🇸🇳", code: 221 },
      { icon: "🇷🇸", code: 381 },
      { icon: "🇸🇨", code: 248 },
      { icon: "🇸🇱", code: 232 },
      { icon: "🇸🇬", code: 65 },
      { icon: "🇸🇰", code: 421 },
      { icon: "🇸🇮", code: 386 },
      { icon: "🇸🇧", code: 677 },
      { icon: "🇸🇴", code: 252 },
      { icon: "🇿🇦", code: 27 },
      { icon: "🇸🇸", code: 211 },
      { icon: "🇪🇸", code: 34 },
      { icon: "🇱🇰", code: 94 },
      { icon: "🇸🇩", code: 249 },
      { icon: "🇸🇷", code: 597 },
      { icon: "🇸🇿", code: 268 },
      { icon: "🇸🇪", code: 46 },
      { icon: "🇨🇭", code: 41 },
      { icon: "🇸🇾", code: 963 },
      { icon: "🇹🇼", code: 886 },
      { icon: "🇹🇯", code: 992 },
      { icon: "🇹🇿", code: 255 },
      { icon: "🇹🇭", code: 66 },
      { icon: "🇹🇬", code: 228 },
      { icon: "🇹🇰", code: 690 },
      { icon: "🇹🇴", code: 676 },
      { icon: "🇹🇳", code: 216 },
      { icon: "🇹🇷", code: 90 },
      { icon: "🇹🇲", code: 7370 },
      { icon: "🇹🇻", code: 688 },
      { icon: "🇺🇬", code: 256 },
      { icon: "🇺🇦", code: 380 },
      { icon: "🇦🇪", code: 971 },
      { icon: "🇬🇧", code: 44 },
      { icon: "🇺🇸", code: 1 },
      { icon: "🇺🇾", code: 598 },
      { icon: "🇺🇿", code: 998 },
      { icon: "🇻🇺", code: 678 },
      { icon: "🇻🇪", code: 58 },
      { icon: "🇻🇳", code: 84 },
      { icon: "🇪🇭", code: 212 },
      { icon: "🇾🇪", code: 967 },
      { icon: "🇿🇲", code: 260 },
      { icon: "🇿🇼", code: 26 },
    ],
    "code",
  ),
  (c) => `${c.icon} +${c.code}`,
);

const Phone: React.FC<any> = (props) => {
  const [number, setNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");

  useEffect(() => {
    if (!props.value && config.default_country_code) {
      setCountryCode(config.default_country_code);
    } else if (props.value) {
      const valueSplit = props.value.split(" ");
      setCountryCode(valueSplit[0]);
      setNumber(props.value.replace(`${valueSplit[0]} `, ""));
    }
  }, [props.value]);

  const handleCountryCode = useCallback(
    (e: any, number: any) => {
      setCountryCode(e.detail.value);

      const value = e.detail.value && number ? [e.detail.value, number].join(" ") : null;
      const ionEvent = new CustomEvent("ionChange", {
        detail: {
          name: props.name,
          value: value,
        },
      });
      props.onIonChange(ionEvent);
    },
    // eslint-disable-next-line
    [props.name, props.onIonChange],
  );

  const handleNumber = useCallback(
    (e: any, countryCode: any) => {
      // todo: improve use of auto selecting country code
      if (countryCode === "") {
        const codes = Object.keys(dialingCodes).filter((l: string) => l.indexOf(e.detail.value) >= 0);

        if (codes.length >= 1) {
          setCountryCode(codes[0]);
        }
      }

      setNumber(e.detail.value);

      const value = e.detail.value && countryCode ? [countryCode, e.detail.value].join(" ") : null;
      const ionEvent = new CustomEvent("ionChange", {
        detail: {
          name: props.name,
          value: value,
        },
      });
      props.onIonChange(ionEvent);
    },
    [props],
  );

  const { disabled } = props;

  return disabled ? (
    <InputFactory placeholder={props.value ? props.value : "-"} disabled={true} />
  ) : (
    <>
      <div className={"input__container--type-phone__inner"}>
        <InputFactory type="select" value={countryCode} placeholder={"Ext."} options={dialingCodes} className="input__input" onIonChange={(e: any) => handleCountryCode(e, number)} />
        <InputFactory type="text" value={number} placeholder={props.placeholder} className="input__input" inputmode="tel" onIonChange={(e: any) => handleNumber(e, countryCode)} />
      </div>
    </>
  );
};

export default Phone;
